import React from 'react';
import './Legal.css';
import { useNavigate, Link } from 'react-router-dom';

const TermsOfService = () => (
  <div className="legal-container">
    <h1 className="legal-title">Terms of Service</h1>

    <section className="legal-section stripe-light">
      <h2>1. Introduction</h2>
      <p>
        Welcome to OnlyStats. These Terms of Service (“Terms”) govern your use
        of our website, services, and applications. By accessing or using
        OnlyStats, you agree to be bound by these Terms.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old and capable of forming a binding
        contract with us. By using OnlyStats, you represent and warrant that
        you meet these requirements.
      </p>
    </section>

    <section className="legal-section stripe-light">
      <h2>3. User Accounts</h2>
      <p>
        To access certain features, you must register for an account.
        You are responsible for safeguarding your credentials and for all
        activity under your account. Notify us immediately of any unauthorized
        use.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>4. Content</h2>
      <p>
        All reviews, ratings, and user-generated content remain the property
        of their authors. By posting, you grant OnlyStats a worldwide,
        perpetual, royalty-free license to display, distribute, and promote
        such content.
      </p>
    </section>

    <section className="legal-section stripe-light">
      <h2>5. Prohibited Conduct</h2>
      <p>
        You may not post unlawful, defamatory, or infringing content. You may
        not spam, harass other users, or attempt to manipulate our systems.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>6. Limitation of Liability</h2>
      <p>
        OnlyStats is provided “as is.” To the maximum extent permitted by law,
        we disclaim all warranties and shall not be liable for any indirect,
        incidental, or consequential damages.
      </p>
    </section>

    <section className="legal-section stripe-light">
      <h2>7. Governing Law</h2>
      <p>
        These Terms are governed by the laws of your jurisdiction, without
        regard to conflict-of-law principles. Any dispute shall be resolved
        in the courts located within that jurisdiction.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>8. Changes</h2>
      <p>
        We may modify these Terms at any time. We’ll post the updated Terms
        here, and your continued use constitutes acceptance of the new Terms.
      </p>
    </section>

    <footer className="legal-footer">
      <p>© 2025 OnlyStats. All rights reserved.</p>
      {/* <p>
        Have questions? <a href="/contact">Contact us</a>.
      </p> */}
    </footer>
  </div>
);

export default TermsOfService;
